import { combineReducers } from 'redux';

import { Reducer } from '../../../../types';
import { StateVideoList, ScriptEditorAction } from '../../types';

import { stripItems } from '../../../../../utility/store';
import {
  getVideoListRequest,
  getVideoListSuccess,
  getVideoListFail,
  setOpenVideoInstructionModal,
} from '../../actions';

type ReducerOf<T extends keyof StateVideoList> = Reducer<StateVideoList, ScriptEditorAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getVideoListRequest.type:
      return state ? stripItems(state) : null;

    case getVideoListSuccess.type:
      return action.payload;

    case setOpenVideoInstructionModal.type:
      return action.payload ? state : null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getVideoListRequest.type:
      return true;

    case getVideoListSuccess.type:
    case getVideoListFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateVideoList>({
  data,
  loading,
});
